import React from "react"
import InfograficaPage9 from '../../components/mobile/Capitolo2/InfograficaPage9'

const Page9Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-6 font-20 line-height-26'>
          Eppure l’elettrico in Italia resta ancora una frontiera in via di esplorazione:
          sebbene in crescita, nelle flotte aziendali solo l’1.5
          per cento delle auto presenta, nel 2019, l’alimentazione elettrica.
        </div>
        <div className='mt-2 font-20 line-height-26'>
          I motivi della scarsa propensione dei fleet manager a passare
          a un veicolo elettrico sono diversi, ma Edison – per superare
          queste stesse barriere – ha lanciato il servizio Fleet Audit.
        </div>
        <div className='mt-5'>
          <div className='mt-5 barra-arancio'></div>
          <div className='mt-1 text-center'>
            <InfograficaPage9 />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page9Mobile
